import { render, staticRenderFns } from "./breatheStatistics.vue?vue&type=template&id=1a7f5fc9&scoped=true&"
import script from "./breatheStatistics.vue?vue&type=script&lang=js&"
export * from "./breatheStatistics.vue?vue&type=script&lang=js&"
import style0 from "./breatheStatistics.vue?vue&type=style&index=0&id=1a7f5fc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f5fc9",
  null
  
)

export default component.exports